import Modal from "./Modal";
import FolderPicker from "./FolderPicker";

export default function MoveCopyDialog({ mode, count, folders, excludePath, onClose, onPick }) {
  return (
    <Modal title={`${mode === "copy" ? "Copy" : "Move"} ${count} item(s) to…`} onClose={onClose} width="420px">
      <FolderPicker folders={folders} excludePath={excludePath} onPick={onPick} />
    </Modal>
  );
}
